

































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Popup } from '@questelservices/common-vue';
import { DxButton, DxTextBox, DxSelectBox } from 'devextreme-vue';
import { DxValidator, DxEmailRule, DxCustomRule, DxRequiredRule } from 'devextreme-vue/validator';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import DataSource from "devextreme/data/data_source";
import CommonModule, { QuestelServicesClient, HttpMethodEnum, RequestResult } from '@questelservices/common';    
import { ClientService } from '@/service/ClientService';
import { SelectOption } from '@/models/SelectOption';
import { Prop } from 'vue-property-decorator';
import { alert } from 'devextreme/ui/dialog';
import { AgentDto } from '../../models/agent/AgentDto';
import { AgentService } from '../../service/AgentService';
import { ClientAgentService } from '../../service/ClientAgentService';
import { ClientDto } from '../../models/client/ClientDto';    
import { CountryDto } from '../../models/CountryDto';    
import { ClientAgentInfoDto } from '../../models/client-agent/ClientAgentInfoDto';
import DxValidationGroup from 'devextreme-vue/validation-group'
import ValidationGroup from "devextreme/ui/validation_group";
import _ from 'lodash';

@Component({
    components: {
        DxButton,            
        Popup,            
        DxTextBox,            
        DxToolbarItem,
        DxSelectBox,            
        DxValidator,
        DxCustomRule,
        DxScrollView,            
        DxValidationGroup,
        DxRequiredRule
    }
})
export default class CreateNewAgent extends Vue {
    public $refs: Vue['$refs'] & {
        validationGroupRef? : ValidationGroup;
    } = {};
    
    @Prop({ default: false })
    showDialog!: boolean;        

    clientsDataSource: SelectOption[] = []; 
    agents: AgentDto[] = [];
    clientAgentInfo: ClientAgentInfoDto = new ClientAgentInfoDto();
    createNewAgent: boolean = false;
    
    readonly emptyGuid: string = "00000000-0000-0000-0000-000000000000";

    //primaryAgentName: string = this.agentInfoData.AgentName;
    get showingDialog() {
        return this.showDialog;
    }

    set showingDialog(value) {
        this.$emit("hidingCreateNewAgent", this.clientAgentInfo, false);
    }


    @Watch("showDialog")
    onPropertyChanged(value: boolean, oldValue: boolean) {                
        if (value) {             
           this.clientAgentInfo = new ClientAgentInfoDto(); 
           this.createNewAgent = false;
           this.validationGroup.reset();
        }            
    }   

    private get validationGroup() {
        return ((this.$refs.validationGroupRef as ValidationGroup).instance as any); 
    }
   
    constructor() {
        super();                           
        this.loadData();       
    }        

    async loadData() { 
        let clientService = new ClientService();
        let clients = await clientService.getAll();
        this.clientsDataSource = clients.map(c => {
        return { text: c.ClientName, value: c.ClientId };
        });           
        
        let agentService = new AgentService();
        let agents = await agentService.getAll();
        this.agents = agents;
    }       

    async refreshAgents() {
        let agentService = new AgentService();
        let agents = await agentService.getAll();
        this.agents = agents;
    }

    hidingCreate() {
        this.showingDialog = false;
    }

    onHidden() {
        this.$emit("createNewAgentHidden", this.clientAgentInfo, this.createNewAgent);
    }

    async confirmSave() {
        let validation = this.validationGroup.validate();
        if(!validation.isValid){
            return;
        }
        
        if (this.agents.some(a => a.AgentName.toLowerCase() == this.clientAgentInfo.Agent.AgentName.trim().toLowerCase())) {
            let message = 'An agent with this name already exists.';
            alert(message, 'Error');
            return;
        }

        this.clientAgentInfo.Agent.AgentId = this.emptyGuid;
        this.clientAgentInfo.PrimaryAlias.ClientAgentAliasId = this.emptyGuid;
        this.clientAgentInfo.Client.ClientName = this.clientsDataSource.filter(c => c.value == this.clientAgentInfo.Client.ClientId)[0].text;
        this.createNewAgent = true;

        this.hidingCreate();                        
    }
}
